import { CreditCardTypes } from "app/models/ss-api/responses/credit.card.response";
import { FormControl } from '@angular/forms';

export class CardTypeInfo {

    public RegEx : RegExp;
    public Length : number;
    public Type : CreditCardTypes;
    
    constructor( regEx : RegExp, length : number, type : CreditCardTypes)
    {
        this.RegEx = regEx;
        this.Length = length;
        this.Type = type;
    }


    

}

export class CreditCardHelper {


    public static GetCardType( number : string ) : string {
        // visa
        var re = new RegExp("^4");
        if (number.match(re) != null)
            return "Visa";

        // Mastercard 
        // Updated for Mastercard 2017 BINs expansion
        if (/^(5[1-5][0-9]{14}|2(22[1-9][0-9]{12}|2[3-9][0-9]{13}|[3-6][0-9]{14}|7[0-1][0-9]{13}|720[0-9]{12}))$/.test(number)) 
            return "Mastercard";

        // AMEX
        re = new RegExp("^3[47]");
        if (number.match(re) != null)
            return "AMEX";

        // Discover
        re = new RegExp("^(6011|622(12[6-9]|1[3-9][0-9]|[2-8][0-9]{2}|9[0-1][0-9]|92[0-5]|64[4-9])|65)");
        if (number.match(re) != null)
            return "Discover";

        // Diners
        re = new RegExp("^36");
        if (number.match(re) != null)
            return "Diners";

        // Diners - Carte Blanche
        re = new RegExp("^30[0-5]");
        if (number.match(re) != null)
            return "Diners - Carte Blanche";

        // JCB
        re = new RegExp("^35(2[89]|[3-8][0-9])");
        if (number.match(re) != null)
            return "JCB";

        // Visa Electron
        re = new RegExp("^(4026|417500|4508|4844|491(3|7))");
        if (number.match(re) != null)
            return "Visa Electron";

        return "";
    }

    


    private static _cardTypeInfo : CardTypeInfo[] = [
        
        // FROM NICK - These are from the backend code, don't seem to work in Angular
        new CardTypeInfo( new RegExp("^(51|52|53|54|55)"), 16, CreditCardTypes.MasterCard),
        new CardTypeInfo( new RegExp("^(4)"), 16, CreditCardTypes.VISA),
        new CardTypeInfo( new RegExp("^(4)"), 13, CreditCardTypes.VISA),
        new CardTypeInfo( new RegExp("^(34|37)"), 15, CreditCardTypes.AmericanExpress),
        new CardTypeInfo( new RegExp("^(6011)"), 16, CreditCardTypes.Discover),
        new CardTypeInfo( new RegExp("^(300|301|302|303|304|305|36|38)"), 14, CreditCardTypes.DinersClub),
        new CardTypeInfo( new RegExp("^(3)"), 16, CreditCardTypes.JCB),
        new CardTypeInfo( new RegExp("^(2131|1800)"), 15, CreditCardTypes.JCB),
        new CardTypeInfo( new RegExp("^(2014|2149)"), 15, CreditCardTypes.EnRoute),

        // new CardTypeInfo( new RegExp("^(51|52|53|54|55)"), 16, CreditCardTypes.MasterCard),
        // new CardTypeInfo( new RegExp("^4"), 16, CreditCardTypes.VISA),
        // new CardTypeInfo( new RegExp("^4"), 13, CreditCardTypes.VISA),
        // new CardTypeInfo( new RegExp("^(34|37)"), 15, CreditCardTypes.AmericanExpress),
        // new CardTypeInfo( new RegExp("^(6011)"), 16, CreditCardTypes.Discover),
        // new CardTypeInfo( new RegExp("^(300|301|302|303|304|305|36|38)"), 14, CreditCardTypes.DinersClub),
        // new CardTypeInfo( new RegExp("^(3)"), 16, CreditCardTypes.JCB),
        // new CardTypeInfo( new RegExp("^(2131|1800)"), 15, CreditCardTypes.JCB),
        // new CardTypeInfo( new RegExp("^(2014|2149)"), 15, CreditCardTypes.EnRoute),
    
    ];



    public static GetCardTypes( cardNumber : string ) : CreditCardTypes {
        //Replace any spaces, periods, etc.
        cardNumber = cardNumber.replace("[^0-9]", "");

        for ( var i = 0; i < this._cardTypeInfo.length; i++ ) {
            
            let item = this._cardTypeInfo[i];
        
            if( cardNumber.length == item.Length && cardNumber.match( item.RegEx ) != null ) {
                return item.Type;
            }
        
        }

        return CreditCardTypes.Unknown;

    }


}






